import { render, staticRenderFns } from "./UltimaAtualizacao.vue?vue&type=template&id=5d827319"
import script from "./UltimaAtualizacao.vue?vue&type=script&lang=js"
export * from "./UltimaAtualizacao.vue?vue&type=script&lang=js"
import style0 from "./UltimaAtualizacao.vue?vue&type=style&index=0&id=5d827319&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports